import React from 'react';
import { PRODUCT_DETAIL_LIST_COL_SIZE_LIST } from '../../constants';
import { translate } from '../../Services/translation';

const DetailedListTopBar = () => {
  return (
    <div className="hidden gap-4 rounded-t border-x border-y border-gray-200 bg-gray-50 p-3 lg:flex">
      <div
        style={{ width: `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[0]}%` }}
      ></div>
      <div
        className="text-md font-bold xl:text-lg"
        style={{ width: `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[1]}%` }}
      >
        {translate('detailed-product-card.article-id')}
      </div>
      <div
        className="text-md font-bold xl:text-lg"
        style={{ width: `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[2]}%` }}
      >
        {translate('detailed-product-card.collection')}
      </div>
      <div
        className="text-md font-bold xl:text-lg"
        style={{ width: `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[3]}%` }}
      >
        {translate('detailed-product-card.stock')}
      </div>
      <div
        className="text-md font-bold xl:text-lg"
        style={{ width: `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[4]}%` }}
      >
        {translate('detailed-product-card.quantity')}
      </div>
      <div
        className="text-right text-md font-bold xl:text-lg"
        style={{ width: `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[5]}%` }}
      >
        {translate('detailed-product-card.price')}
      </div>
      <div
        className="text-md font-bold xl:text-lg"
        style={{ width: `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[6]}%` }}
      >
        {translate('detailed-product-card.boxes')}
      </div>
      <div
        className="text-md font-bold xl:text-lg"
        style={{ width: `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[7]}%` }}
      >
        {translate('detailed-product-card.rolls')}
      </div>
      <div
        className="text-md font-bold xl:text-lg"
        style={{ width: `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[8]}%` }}
      >
        {translate('detailed-product-card.total')}
      </div>
      <div
        style={{ width: `${PRODUCT_DETAIL_LIST_COL_SIZE_LIST[9]}%` }}
      ></div>
    </div>
  );
};

export default DetailedListTopBar;
